export default "__VITE_ASSET__CE22PGq0__"